import { render } from "./LoginFrame.vue?vue&type=template&id=0c802f43&scoped=true"
import script from "./LoginFrame.vue?vue&type=script&lang=js"
export * from "./LoginFrame.vue?vue&type=script&lang=js"

import "./LoginFrame.vue?vue&type=style&index=0&id=0c802f43&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c802f43"]])

export default __exports__